import React from "react";
import { Spin } from "antd";
import "./RoutingEngine.scss";
import { ReactSVG } from "react-svg";
import { ENGINE_TYPE, ENGINE_TYPE_TRANSLATION } from "../../../constants";

const RoutingEngineSettingsForm = ({ isFetching, setting }) => {
  return (
    <Spin spinning={isFetching}>
      <div className="SettingsForm RoutingEngineSettings">
        <h3>Routing Engine</h3>
        <div className="content">
          <p>Current routing engine:</p>
          <div className="engine-type">
            <ReactSVG className="icon" src="/icons/check.svg" />
            <b>{ENGINE_TYPE_TRANSLATION[setting?.engineType || ENGINE_TYPE.OSRM]}</b>
          </div>
        </div>
        <div className="content key-content">
          <b className="small-title">Google Maps API Key</b>
          <div className="key">
            {setting?.googleDirectionsKey ? `•••••••••••••••••••••••••••••••${setting?.googleDirectionsKey}` : "-"}
          </div>
        </div>
        <div className="content">
          <p>Other available routing engines:</p>
          <ul>
            {Object.keys(ENGINE_TYPE_TRANSLATION)
              .filter(engine => engine !== setting?.engineType)
              .map(engine => (
                <li key={engine}>
                  <p>{ENGINE_TYPE_TRANSLATION[engine]}</p>
                  {engine === ENGINE_TYPE.GMPRO ? (
                    <>
                      <div className="divider-left"></div>
                      <p className="integration-link">
                        (please contact <a href="mailto:afian@afi.io">afian@afi.io</a> for integration)
                      </p>
                    </>
                  ) : (
                    <></>
                  )}
                </li>
              ))}
          </ul>
        </div>
      </div>
    </Spin>
  );
};

export default RoutingEngineSettingsForm;
